import requests from "../util";
import { type IImage } from "./types";

const url = "images";

const imagesApi = {
    getImagesByEntity: async (entity: string, entityId: string): Promise<IImage[]> =>
        await requests.get(`${url}/entity/${entity}/${entityId}`),

    deleteImageById: async (id: string): Promise<IImage> =>
        await requests.delete(`${url}/${id}`),

    findByUserId: async (userId: string): Promise<IImage> =>
        await requests.get(`${url}/users/${userId}`),

    findByStoreId: async (storeId: string): Promise<IImage> =>
        await requests.get(`${url}/stores/${storeId}`)
};

export default imagesApi;